<template>
    <div style="display: inline-block;">
        <div :id="uid" class="modal bottom-sheet" style="left: 0">
            <div class="modal-header">
                <a class="modal-close waves-effect waves-green btn-flat"><span class="material-icons">close</span></a>
            </div>
            <div class="modal-content">
                <h6>{{substance.name}}</h6>
                <preloader v-if="!loaded" />
                <template v-if="loaded">
                    <img v-if="substance_details.image != undefined" :src="substance_details.image" />
                    <div><b>{{$t('substances.permission')}}:</b> {{substance_details.permission}}</div>
                    <div><b>{{$t('substances.dosage')}}:</b> {{substance_details.dosage}}</div>
                    <ul class="list-group">
                        <li class="list-group-item ng-scope" v-for="doc in substance_details.documents" style="">
                            <a download="" :href="doc.attachment.url" class="ng-binding">
                                <div class="fa fa-file-pdf-o"></div>
                                {{$t("substances.documents."+doc.doctype)}}

                            </a>
                        </li>
                    </ul>
                    <p />
                </template>
            </div>
        </div>
        <div :data-target="uid" class="modal-trigger" style="text-decoration: underline dashed;" v-on:click="load_substance()">{{substance.name}}</div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function() {
        return {
            uid: _.uniqueId("substancepopup"),
            loaded: false,
            substance_details: {}
        }
    },
    mounted: function() {
        var elemss = this.$el.querySelectorAll('.modal');
        this.instance = M.Modal.init(elemss, {
            onOpenStart: () => {
            }
        });
    },
    created: function() {

    },
    methods: {
        load_substance: async function() {
            var response = await axios.get('/substances/' + this.substance.id + '.json');
            this.loaded = true;
            this.substance_details = response.data
        }
    },
    props: { substance: Object },
    computed: {

    },

}
</script>
<style scoped>
div {
    margin-left: auto;
    left: auto;
    right: auto;
    line-height: 2;
}
</style>